import { useNtaskApi, useAuthStorage } from '~/composables'

export default defineNuxtPlugin(async () => {

  if (process.server) return

  const { getToken, getCurrentUser, clearAuthData } = useAuthStorage()
  const { auth } = useNtaskApi()

  const existingToken = getToken()
  const existingUser = getCurrentUser()
  
  // if (existingToken && existingUser) {
  //   try {
  //     await auth.authenticateWithToken(existingToken)
  //   } catch (error: any) {
  //     console.error('Failed to validate existing token:', error)
  //     if (error.status === 401) {
  //       clearAuthData()
  //     }
  //   }
  // }
}) 